import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ArchospiEffects } from './state/archospi.effects';
import { arcHospiFeatureKey, arcHospiReducer } from './state/archospi.reducer';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(arcHospiFeatureKey, arcHospiReducer),
    EffectsModule.forFeature([ArchospiEffects])
  ]
})
export class ArchospiModule { }
